import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mapnavComponent from './mapnav.component';

let mapnavModule = angular.module('mapnav', [
  uiRouter
])

.component('mapnav', mapnavComponent)

.name;

export default mapnavModule;
